
export function clickFormItem(){
    for(let label of document.querySelectorAll(".wpcf7-list-item > label")){
        label.addEventListener("click",function (){
            let radio = label.querySelector("input[type='radio'],input[type='checkbox']");
            if(radio){
                radio.click();
            }
        })
    }
}